import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { Timestamp } from 'firebase/firestore'

// Define a type for the slice state
export interface User {
    id: string,
    name: string,
    email: string,
    actual_subscription_id: string,

    title_subscription: string,
    subscription_type_id: string,
    max_message_duration: number,
    price_per_month: number,
    subscription_duration: number,
    date_subscription: any,
    description_subscription: string,
    date_expiration_subscription: any,

    timestamps: any,
}

interface UserState {
    user: User,
}

// Define the initial state using that type
const initialState: UserState = {
    user: {
        id: "",
        name: "",
        email: "",
        actual_subscription_id: "",

        title_subscription: "Free plan",
        subscription_type_id: "1",
        max_message_duration: 15,
        price_per_month: 0,
        subscription_duration: 60,
        date_subscription: Timestamp.now(),
        description_subscription: "Your messages remain 15 min before disappear",
        date_expiration_subscription: Timestamp.now(),

        timestamps: Timestamp.now(),
    }
}


export const userSlice = createSlice({
    name: 'user',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        setUser: (state, action: PayloadAction<any>) => {
            console.log("setting user...: ", action.payload)
            state.user = action.payload
        },
    },
})

export const { setUser } = userSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectUser = (state: RootState) => state.user.user

export default userSlice.reducer